<div id="how-it-works">
  <div class="container tw-p-0 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-min-h-[100vh]">
    <div class="tw-cols-span-1 tw-flex tw-justify-center tw-p-[2%] md:tw-p-[5%] tw-items-center">
      <img src="/assets/images/how-it-works.png" alt="how PumPumPum works?" />
    </div>
    <div
      class="tw-cols-span-1 tw-gap-4 tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-[5%] md:tw-p-[10%] lg:tw-p-[15%]">
      <p class="tw-text-center tw-text-xl md:tw-text-2xl lg:tw-text-3xl tw-font-extrabold">How PumPumPum Works</p>
      <p class="tw-text-center tw-text-gray-700 tw-px-4 md:tw-px-8">Subscribe to a car in India in just 3 simple steps
        and become a proud car owner</p>

      <div *ngFor="let step of processSteps"
        class="tw-bg-white tw-flex tw-items-center tw-rounded-md tw-gap-4 tw-w-full tw-p-4">
        <div class="tw-bg-yellowLight tw-w-14 tw-h-14 tw-p-3 tw-flex-shrink-0 tw-rounded-md">
          <img class="tw-w-14" [src]="step.image" [alt]="step.title">
        </div>
        <div class="tw-flex tw-flex-col">
          <p class="tw-font-bold">{{step.title}}</p>
          <p class="tw-text-sm tw-text-[#4B4B4B]">{{step.description}}</p>
        </div>
      </div>
    </div>
  </div>
</div>